import axios from "axios";
import Api from "./Api";

export default class Repository {
    /**
     * @param page
     * @param search
     * @param per_page
     */
    async getSpeakers(page = null, search = null, per_page = 10) {
        let params = {
            client: 'self',
            orderby: 'title',
            order: 'asc',
            meta_key: 'oficial',
            meta_value: 1,
        };

        if (typeof page === 'number' && page > 0) {
            params.page = page;
        }

        if (typeof per_page === 'number' && per_page > 0) {
            params.per_page = per_page;
        }

        if (typeof search === 'string' && search !== '') {
            params.search = search;
        }

        return await axios.get(new Api().getSpeakersIndexUrl(), {
            params: params,
        });
    }

    async getSpeaker(speaker_slug) {
        return await axios.get(new Api().getSpeakersShowUrl(), {
            params: {
                client: 'self',
                slug: speaker_slug,
            }
        });
    }

    async getSchedules(day = null, stage = null, tag_id = null, search = null) {
        let params = {
            client: 'self',
            no_paging: true,
        };

        if (tag_id !== null) {
            params['tags'] = tag_id;
        }

        if (day !== null) {
            params['meta_key'] = 'data_e_hora_dia';
            params['meta_value'] = day.replaceAll('-', '');
        }

        if (stage !== null) {
            params['palcos'] = stage;
        }

        if (search !== null && search !== '') {
            params['search'] = search;
        }

        return await axios.get(new Api().getSchedulesIndexUrl(), {
            params: params,
        });
    }

    async getStages(search = null, parent_stage_id = null) {
        let params = {no_paging: true};

        if (parent_stage_id !== null) {
            params['parent'] = parent_stage_id;
        }

        if (search !== null) {
            params['search'] = search;
        }

        return await axios.get(new Api().getScheduleStages(), {
            params: params,
        });
    }

    async getTags() {
        return await axios.get(new Api().getScheduleTags(), {
            params: {
                no_paging: true,
            }
        });
    }

    async getEventDays() {
        return await axios.get(new Api().getEventDays(), {
            params: {
                client: 'self',
                meta_key: 'data_e_hora_dia',
                meta_value: -1,
            }
        });
    }
}
